// extracted by mini-css-extract-plugin
export default {"form_create":"create_form_create__bCtPc","btns":"create_btns__BPXr+"};